// extracted by mini-css-extract-plugin
export default {"modal":"j9tQaBqfgT_ByMiygHiR","list":"sVK7JfR1Fg9rHtjNqU9Q"};